import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../store/features/LoginSlice';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, accessToken, loading, error: authError } = useSelector(
    (state) => state.auth
  );



  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password }));
  };

  useEffect(() => {
    if (authError) {
      setError(authError);
    } else if (user && accessToken) {
      navigate('/dashboard');
    }
  }, [authError, user, accessToken, navigate]);



  return (
    <form
      className="flex flex-col mb-0 max-w-full padding:no max-md:mb-2.5"
      onSubmit={handleLogin}
    >
      <h2 className="self-start text-2xl font-medium text-font">Log in</h2>
      <p className="self-start py-1 text-sm text-font-LIGHT">
        Welcome back! Please log in to your account
      </p>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      <div className="flex flex-col mt-4 text-l text-neutral-500 max-w-full">
        <div className="relative py-4">
          <label htmlFor="email" className="sr-only">
            Email Address
          </label>
          <input
            id="email"
            type="email"
            className="h-12 w-2/3 bg-white rounded-xl border-black border-solid border-[1.5px] py-3 pr-4 pl-4 text-black placeholder-font-LIGHT focus:outline-none focus:ring-2 focus:ring-logo focus:border-transparent"
            aria-label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="morwenna.napier@bae.com"
            required
          />
        </div>
        <div className="relative">
          <label htmlFor="password" className="sr-only">
            Password
          </label>
          <input
            id="password"
            type="password"
            className="h-12 w-2/3 bg-white rounded-xl border-black border-solid border-[1.5px] pr-4 pl-4 text-black placeholder-font-LIGHT focus:outline-none focus:ring-2 focus:ring-logo focus:border-transparent"
            aria-label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="*******"
            required
          />
        </div>
      </div>
      <a
        href="#"
        className="self-start text-sm py-2 px-1 text-font-LIGHT underline decoration-1 underline-offset-4 hover:decoration-gray-600"
      >
        Forgotten password?
      </a>
      <button
        type="submit"
        className="align-middle h-12 gap-2.5 w-2/3 items-center text-xl px-6 my-4 bg-logo rounded-3xl text-font-HIGHLIGHT transition-transform duration-200 transform hover:bg-logo-darker"
      >
        Log in
      </button>
  </form>
  );
}

export default LoginForm;